import React from 'react';
import './user_profile.less';
import DashBoardHeader from '../header_dashboard/dashboard_header';
import LoggedinFooter from '../footer/loggedin_footer';
import moment from 'moment';
import UserReviewThread from '../components/user_review_thread/user_review_thread.jsx'
import userProfileActions from './user_profile_actions.jsx';
import Rating from '../components/rating/rating';
import commonFunctions from '../commoon_functions.jsx';
import $ from 'jquery';
import ConfirmBox from '../components/confirm_box/confirm_box.jsx';
import ShowError from '../components/error/show_error.jsx';
import SuccessMessage from '../components/success/success_msg.jsx';

import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {routerActions} from 'react-router-redux';

class UserProfile extends React.Component{
  constructor(props){
    super(props);
    this.state = {
      isLoading: '',
      error: '',
      offsetIncrement: 10,
      offset: 0,
      totalCount: 11,
      count: 10,
      userId: '',
      successMsg: '',
      popupState: false
    }
  }


  getUserId = () =>{
    let  url = this.props.location.pathname.split('/');
    let userId = url[url.length-1];
    return userId;
  }

  getProfileReviews = (userId, refreshData, offsetValue) =>{
    const {state} = this;

    let {offsetIncrement} = state;
    let {count} = state;
    let {totalCount} = state;
    let offset;
    (offsetValue == null || offsetValue == undefined) ? (offset = state.offset) : (offset = offsetValue);

    if(offset >= state.totalCount){
      return;
    }

    let pageObj = {
       offsetIncrement: offsetIncrement,
       offset: offset,
       totalCount: totalCount
   };
   let url_params = {
       encryptedUserId: userId,
       offset: offset,
       count: count
   }
   this.setState({
       isLoading: true
   });
   this.props.userProfileActions.getProfileReviews(url_params, refreshData).then( (successData) => {
       offset = commonFunctions.paginate(pageObj);
       this.setState({
           offset: offset,
           isLoading: false
       });

   },(errorRes) => {
       this.setState({
        isLoading: false,
        error: errorRes.error
       });
   })
  }

  viewProfile = (userId)=>{
    let params = {
      encryptedUserId: userId
    };
    let offset = 0;
    this.setState({isLoading: true});
    this.props.userProfileActions.viewProfile(params).then((successData)=>{
      this.setState({totalCount: successData.totalNoOfRatings, offset: 0},   this.getProfileReviews(userId, true, offset));
    }, (errorRes)=>{
      this.setState({isLoading: false, error: errorRes.error});
    })
  }

  profileReview = (reviewArr) => {
     if(reviewArr == undefined || reviewArr == null){
       return null;
     }
     let totalReview = [];
     if(reviewArr.length > 0){
         reviewArr.map((reviewObj, index) => {
             totalReview.push(<UserReviewThread key={index} reviewObj = {reviewObj}/>);
          })
         return totalReview;
     }
     return [];
  }

  reportUser = () => {
    let params = {
      reportedUser: this.state.userId
    }
    this.setState({isLoading: true});
    this.props.userProfileActions.reportUser(params).then((successData)=>{
      this.setState({isLoading: false, successMsg: ''});
      let userId = this.getUserId();
      this.viewProfile(userId);
      window.setTimeout(()=>{
        this.setState({successMsg: ''});
      }, 5000);

    }, (errorRes)=>{
      this.setState({error: errorRes.error, isLoading: false});
      window.setTimeout(()=>{
        this.setState({error: ''});
      }, 5000);
    })
  }

  closePopup = () => {
    this.setState({popupState: false});
  }

  showPopup = () => {
    this.setState({popupState: true});
  }

  componentDidMount(){
    window.scrollTo(0, 0);
    let userId = this.getUserId();
    this.viewProfile(userId);
    this.setState({userId: userId})
    let profileReviews = this.props.userProfile.profileReviews;

    let lastScrollTop = 0;
    let currLocation;
    const {state} = this;
    // call api only when scroll is towards down side
    // and near bottom of the page
    // $(window).scroll( (event)=>{
    //
    //    currLocation = $(window).scrollTop();
    //    if (currLocation > lastScrollTop){
    //         if( (window.innerHeight + window.pageYOffset) >= document.body.offsetHeight ){
    //           if(state.offset < state.totalCount){
    //             this.getProfileReviews(userId, false);
    //           }
    //         }
    //
    //    } else {
    //
    //    }
    //    lastScrollTop = currLocation;
    //
    // });
  }

  // unbind the component so that it doesn't cause the state issue
  componentWillUnmount() {
    //  $(window).unbind("scroll");
  }

  // when url gets updated

  componentWillReceiveProps(newProps){
    window.scrollTo(0, 0);
    const {state} = this;
    let offset = 0;
    let userId = commonFunctions.getUserID(newProps.location.pathname);
    this.setState({offset: 0})
    let profileReviews = this.props.userProfile.profileReviews;
    if(state.userId != userId){
        this.setState({userId: userId});
        this.viewProfile(userId);
        // this.getProfileReviews(userId, true, offset);
    }

  }

  render(){
    const {state, props} = this;
    const self = this;
    const {userData} = props.authState;
    let userProfile = props.userProfile.userProfileData;
    let userProfileReviews = props.userProfile.profileReviews;
    let userProfileReviewsComponent = this.profileReview(userProfileReviews);
    let isUserReported;
    let date;
    let isVerified;
    let averageRating;
    let totalRatings;
    let imageUrl;
    let joinedDate;
    let name;
    let enableLoadMore;
    let userId = state.userId;
    let loggedInUserId = this.props.authState.userData.userId;
    let backTo;
    let enableFlag;
    let query = props.location.query;
    (query && query.backTo) ? (backTo = query.backTo) : (backTo = null);
    (backTo == 'profile' && userId != loggedInUserId) ? (enableFlag = true) : (enableFlag = false);
    let user = {
     name: '',
     imageUrl: '',
     isVerified: '',
     creditAmount: ''
   };

   (state.totalCount > state.offset ) ? (enableLoadMore = true) : (enableLoadMore = false);


   if(props.authState) {
     user.name = userData.name;
     user.imageUrl = userData.profileImageUrl;
     user.isVerified = userData.isVerified;
     user.creditAmount = userData.creditAmount
   }

    user.imageUrl = userData.profileImageUrl || "../../public/images/user_placeholder.svg";

    (userProfile && userProfile.date) ? (date = userProfile.date) : (date = '');
    (userProfile && userProfile.isVerified) ? (isVerified = userProfile.isVerified) : (isVerified = '');
    (userProfile && userProfile.averageRating) ? (averageRating = userProfile.averageRating) : (averageRating = '');
    (userProfile && userProfile.totalRatings) ? (totalRatings = userProfile.totalRatings) : (totalRatings = '');
    (userProfile && userProfile.profileImageUrl) ? (imageUrl = userProfile.profileImageUrl) : (imageUrl = '../../public/images/user_placeholder.svg');
    (userProfile && userProfile.name) ? (name = userProfile.name) : (name = '');
    (userProfile && userProfile.averageRating) ? (averageRating = userProfile.averageRating) : (averageRating = '');
    (userProfile && userProfile.totalNoOfRatings) ? (totalRatings = userProfile.totalNoOfRatings) : (totalRatings = '');
    (userProfile && userProfile.isUserReported) ? (isUserReported = userProfile.isUserReported) : (isUserReported = false);
    (date) ? (joinedDate =  moment.unix(date/1000).format("MMM  YYYY")) : joinedDate = '';


    return(
      <div id="userProfile">
        <DashBoardHeader user={user} />
        <div id="userProfileWrap">
          <div className="header">
            <div className="header-text wrapper">Profile Details</div>
          </div>
          <div className="user-profile-wrap wrapper">
            {state.error && <ShowError errorMessage={state.error} />}
            {state.successMsg && <ShowError errorMessage={state.successMsg} />}
            <div className="other-profile-view-wrap">
                <div className="other-profile-details-wrp">
                    <div className="other-profile-img-wrp">
                        <img className="other-profile-img-elm" src={imageUrl} />
                    </div>
                    <div className="other-profile-details">
                        <div className="user-profile-name">
                          <span>{name}</span>
                          {!isUserReported  && enableFlag && <span onClick={this.showPopup} className="unflagged-img"></span>}
                          {isUserReported && <span className="flagged-img"></span>}
                        </div>
                         {isVerified && <div className="user-profile-verified-wrp">
                             <div className="profile-verified-img-elm"></div><span className="user-profile-verified">Verified</span>
                         </div>}
                        <div className="other-profile-rating-wrp" >
                        <Rating  rating = {averageRating} ratingSize="rating-size10" /><span id="totalRating">({totalRatings})</span>
                        </div>
                        <div className="user-profile-date">Joined {joinedDate}</div>
                    </div>
                </div>
            </div>
            {userProfileReviewsComponent.length > 0 && <div className="rating-header">Reviews</div>}
            <div className="other-reviews-wrap">
              {userProfileReviewsComponent}
              {userProfileReviewsComponent.length == 0 && <div className="no-reviews">No Reviews</div>}
            </div>
            {enableLoadMore && <div className="profile-pagination-wrap" id="userProfilePaginate" onClick={this.getProfileReviews.bind(self, userId, false, null)}>Load More</div>}
          </div>
          {state.isLoading && <div className = "loader-wrapper"><div className = "loader"></div></div>}
          <ConfirmBox popupState={this.state.popupState} closePopupCallback={this.closePopup} onConfirmCallback = {this.reportUser} display header={'Report user'} description={'Do you want to report this user?'}/>
        </div>
        <LoggedinFooter />
      </div>
    )
  }
}

UserProfile = connect((state) => {
  return {
    authState: state.app.auth,
    userProfile: state.app.userProfile
  }
}, (dispatch) => {
  return {
    userProfileActions: bindActionCreators(userProfileActions, dispatch),
  }
})(UserProfile);



export default UserProfile;



// WEBPACK FOOTER //
// app/user_profile/user_profile.jsx